/**
 * SocialMediaAccountService
 * Service for SocialMediaAccount entity operations
 * Route: api/socialmedia/accounts
 */
import { CrudService } from '../base/CrudService';
/**
 * SocialMediaAccountService
 * Handles social media account CRUD operations and sync management
 */
export class SocialMediaAccountService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SocialMediaAccountService.DEFAULT_SERVICE_PATH,
            basePath: SocialMediaAccountService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL WITH PLATFORM FILTER ====================
    /**
     * Get all social media accounts with optional platform filter
     * GET api/socialmedia/accounts?platform={platform}
     */
    async getAll(platform) {
        const response = await this.getAllRaw(platform);
        return response.data ?? [];
    }
    /**
     * Get all social media accounts with full response
     */
    getAllRaw(platform) {
        const endpoint = this.getEndpoint('list', '');
        const url = this.buildUrl(endpoint);
        const urlWithParams = platform ? `${url}?platform=${encodeURIComponent(platform)}` : url;
        return this.http.get(urlWithParams);
    }
    // ==================== TRIGGER SYNC ====================
    /**
     * Trigger manual sync for an account
     * POST api/socialmedia/accounts/{id}/sync
     */
    async triggerSync(id) {
        const response = await this.triggerSyncRaw(id);
        if (!response.success) {
            throw new Error(response.message || 'Failed to trigger sync');
        }
    }
    /**
     * Trigger manual sync with full response
     */
    triggerSyncRaw(id) {
        const endpoint = this.getEndpoint('sync', `${id}/sync`);
        const url = this.buildUrl(endpoint);
        return this.http.post(url);
    }
}
SocialMediaAccountService.DEFAULT_SERVICE_PATH = 'socialmedia';
SocialMediaAccountService.BASE_PATH = 'api/socialmedia/accounts';
//# sourceMappingURL=SocialMediaAccountService.js.map